import React from 'react';
import { Box, TextField, Button, MenuItem, Link } from '@mui/material';
import SearchCodeSelectbox from '../../common/form/selectbox/SearchCodeSelectbox';
import MobileSearchAdornment from '../../common/search/MobileSearchAdornment';

export const ProductListBox = ({ formik }) => {
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: { xs: 'contents', sm: 'flex' },
            flexDirection: 'row',
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
            alignItems: 'center',
            rowGap: 1,
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box
            sx={{
              order: { xs: 1, sm: 0 },
              flex: { xs: 1, sm: '0 1 auto' },
              minWidth: 0,
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: { xs: 0.5, sm: 1 }, width: { sm: '25ch' } },
              '& > :first-of-type': { flex: { xs: '0 0 38%', sm: '0 1 auto' } },
              '& > :last-of-type': { flex: { xs: 1, sm: '0 1 auto' } },
            }}
          >
            <TextField
              variant="standard"
              required
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              {/* <MenuItem value="">검색키워드</MenuItem> */}
              <MenuItem value="pricePartnerNm">제조사</MenuItem>
              <MenuItem value="productNm">제품명</MenuItem>
              <MenuItem value="modelNm">모델명</MenuItem>
              <MenuItem value="category">분류</MenuItem>

              {/* <MenuItem value="pricePartnerNm">매입처</MenuItem> */}
            </TextField>
            <TextField
              variant="standard"
              required
              id="searchWords"
              name="searchWords"
              label="검색어"
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
              InputProps={{
                endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
              }}
            />
          </Box>

          <Box
            sx={{
              order: { xs: 2, sm: 0 },
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
              sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
            >
              검색
            </Button>
            <Button
              sx={{
                mx: { xs: 0.5, sm: 2 },
                fontSize: { xs: 12, sm: '0.875rem' },
                px: { xs: 1, sm: 2 },
                py: { xs: 0.5, sm: 0.75 },
                minWidth: { xs: 0, sm: 64 },
              }}
              component={Link}
              color="warning"
              variant="outlined"
              target="_blank"
              rel="noopener noreferrer"
              href="/productmng/add"
            >
              제품 등록
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
